var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastCriticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.0001C12.4183 16.0001 16 12.4184 16 8.00012C16 3.58184 12.4183 0.00012207 8 0.00012207C3.58172 0.00012207 0 3.58184 0 8.00012C0 12.4184 3.58172 16.0001 8 16.0001ZM4.46447 4.46458C4.85499 4.07406 5.48816 4.07406 5.87868 4.46459L8 6.58591L10.1213 4.46459C10.5118 4.07407 11.145 4.07407 11.5355 4.46459C11.9261 4.85512 11.9261 5.48828 11.5355 5.87881L9.41422 8.00012L11.5355 10.1214C11.9261 10.512 11.9261 11.1451 11.5355 11.5357C11.145 11.9262 10.5118 11.9262 10.1213 11.5357L8 9.41434L5.87868 11.5357C5.48816 11.9262 4.85499 11.9262 4.46447 11.5357C4.07394 11.1451 4.07394 10.512 4.46447 10.1214L6.58579 8.00012L4.46447 5.8788C4.07394 5.48827 4.07394 4.85511 4.46447 4.46458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCriticalIcon);
export default __webpack_public_path__ + "static/media/toast-critical-icon.1e063edd6c4d0265ccc1fe7ae4e373f8.svg";
export { ForwardRef as ReactComponent };